import React from "react";
import "./NetworkDiagram.css";

// Sanitized homelab network architecture — built as markup, not an image.
// No IPs, no internal FQDNs, no real public domains.
const Node = ({ label, sub, variant }) => (
  <div className={`nd-node ${variant ? `nd-node--${variant}` : ""}`}>
    <span className="nd-node-label">{label}</span>
    {sub && <span className="nd-sub">{sub}</span>}
  </div>
);

// arrow + following node/group, kept together so they wrap as one unit
const Step = ({ children }) => (
  <span className="nd-step">
    <span className="nd-arrow" aria-hidden="true">→</span>
    {children}
  </span>
);

const Group = ({ label, chips }) => (
  <div className="nd-group">
    <span className="nd-group-label">{label}</span>
    <div className="nd-chips">
      {chips.map((c) => (
        <span className="nd-chip" key={c}>
          {c}
        </span>
      ))}
    </div>
  </div>
);

export const NetworkDiagram = () => (
  <figure className="nd">
    <figcaption className="nd-cap mono">{"// network architecture (sanitized)"}</figcaption>

    <div className="nd-zone nd-zone--trusted">
      <span className="nd-zone-label">trusted — internal network</span>
      <div className="nd-flow">
        <Node label="LAN Clients" sub="pc · phone · laptop" />
        <Step>
          <Node label="Pi-hole" sub="split-horizon DNS" variant="accent" />
        </Step>
        <Step>
          <Node label="Nginx Proxy Manager" sub="internal TLS reverse proxy" variant="accent" />
        </Step>
        <Step>
          <Group
            label="internal services"
            chips={["SIEM · Splunk", "Identity · SSO", "Monitoring", "Apps · media"]}
          />
        </Step>
      </div>
      <div className="nd-edge">
        <Node label="UDM Pro" sub="firewall · IDS / IPS · VLANs" variant="edge" />
        <span className="nd-note">management plane stays internal-only</span>
      </div>
    </div>

    <div className="nd-bridge mono">▲ no inbound port forwarding — outbound tunnels only</div>

    <div className="nd-zone nd-zone--public">
      <span className="nd-zone-label">untrusted — public</span>
      <div className="nd-flow">
        <Node label="Internet" />
        <Step>
          <Node label="Cloudflare" sub="DNS + tunnel ingress" variant="warn" />
        </Step>
        <Step>
          <Node label="cloudflared" sub="outbound-only origin" />
        </Step>
        <Step>
          <Group label="public services" chips={["media streaming", "request portal"]} />
        </Step>
      </div>
    </div>
  </figure>
);
